
export default {
  name: 'FiveStarProductsCategoryNavV2',
  props: {
    categoryData: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      activeItemId: 0,
      isAtTop: false,
      categoryActive: false,
    }
  },
  computed: {
  },
  mounted() {
    const element = document.getElementsByClassName("five-star-products-category-nav-v2")[0]
    window.addEventListener('scroll', () => {
      if (window.scrollY > 1000) {
        // console.log('>1000')
        element.classList.add('sticky')
      } else {
        // console.log('<1000')
        element.classList.remove('sticky')
      }
    })

    window.addEventListener('scroll', this.checkPosition);
    this.scrollToElement();
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.checkPosition);
  },

  methods: {
    currentCategoryTitle() {
      if (!this.$route.params.any) return this.$t('fiveStar.filterMenuAll')
      return this.categoryDataInOrder()?.find((item) => item.slug === this.$route?.params?.any )?.CategoryTitle
    },
    categoryDataInOrder() {
      function compare( a, b ) {
        if ( a.DisplayOrder < b.DisplayOrder ){
          return -1;
        }
        if ( a.DisplayOrder > b.DisplayOrder ){
          return 1;
        }
        return 0;
      }
      const ordered = JSON.parse(JSON.stringify(this.categoryData));
      return ordered?.sort( compare );
    },
    toggleActiveItem(i) {
      if (i === this.activeItemId) {
        this.activeItemId = -1
      } else {
        this.setActiveItem(i)
      }
    },

    setActiveItem(i) {
      this.activeItemId = i
    },

    checkPosition() {
      const element = document.getElementsByClassName("five-star-products-category-nav-v2")[0]
      this.isAtTop = Math.abs( element.getBoundingClientRect().top ) < 5;
    },

    scrollToElement() {
        const activeElement = document.getElementsByClassName('item active');
        const offsetLeft = activeElement[0].offsetLeft;
        document.getElementById("scrollableBar").scrollTo(offsetLeft, 0);
        this.categoryActive = true;
    }
  },
}
